<!-- <p>dashboard works!</p> -->

<!-- Spinner overlay -->
<div *ngIf="isLoading" class="spinner-overlay">
  <mat-spinner></mat-spinner>
</div>

<!-- Dashboard migrated and refactored to Angular Material -->
<div id="controls" class="um-toolbar form-inline" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
  <mat-form-field appearance="fill" floatLabel="always" class="form-field search-field-main">
    <mat-label>Enter Site Name</mat-label>
    <input matInput [(ngModel)]="searchInput" (keyup.enter)="applyFilter()" placeholder="Enter Site Name">
  </mat-form-field>

  <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field-wide">
    <mat-label>LOS</mat-label>
    <mat-select panelClass="um-select-panel" [(ngModel)]="selectedLos" (selectionChange)="applyFilter()">
      <mat-option value="">-- All LOS --</mat-option>
      <mat-option *ngFor="let los of losOptions" [value]="los">{{ los }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
    <mat-label>User Type</mat-label>
    <mat-select panelClass="um-select-panel" [(ngModel)]="pvNonPvFilter" (selectionChange)="applyFilter()">
      <mat-option value="">-- All Users --</mat-option>
      <mat-option value="non-pv">Non-PV Users</mat-option>
      <mat-option value="pv">PV Users</mat-option>
    </mat-select>
  </mat-form-field>

  <button mat-raised-button color="primary" (click)="applyFilter()">Apply Filter</button>
  <button mat-stroked-button color="primary" (click)="zoomIn()">Zoom In</button>
  <button mat-stroked-button color="primary" (click)="zoomOut()">Zoom Out</button>
  <button mat-stroked-button color="warn" (click)="clearCache()">Clear Cache</button>
</div>

<!-- Angular Material Legend -->
<div class="legend-bar" style="margin: 10px 0; text-align: center;">
  <ng-container *ngFor="let item of legendItems">
    <span class="legend-color"
          [style.background]="item.color"
          [class.selected]="selectedLos === item.label"
          (click)="onLegendClick(item.label)"></span>
    <span class="legend-label"
          [class.selected]="selectedLos === item.label"
          (click)="onLegendClick(item.label)">
      {{ item.label }} ({{ item.sitesCount }} Sites - {{ item.usersCount }} Users)
    </span>
  </ng-container>
</div>

<div id="chart-wrapper">
  <div id="chart-container" #chartContainer></div>
</div>

<!-- Modal for user list -->
<ng-template #userModal let-data let-dialogRef="dialogRef">
  <h3 mat-dialog-title>{{ data.siteName }}</h3>
  <mat-dialog-content>
    <table id="userTable" style="width:100%">
      <thead>
        <tr><th>#</th><th>User</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of data.users; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ user }}</td>
        </tr>
      </tbody>
    </table>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Close</button>
  </mat-dialog-actions>
</ng-template>

<!-- Vega, Vega-Lite, Vega-Embed scripts -->
<script src="https://cdn.jsdelivr.net/npm/vega@5"></script>
<script src="https://cdn.jsdelivr.net/npm/vega-lite@5"></script>
<script src="https://cdn.jsdelivr.net/npm/vega-embed@6"></script>

<style>
  body { font-family: Arial, sans-serif; padding: 20px; }
  #chart-wrapper {
    overflow-x: auto;
    border: 1px solid #ccc;
    white-space: nowrap;
    padding-bottom: 10px;
    max-width: 100%;
  }
  #controls { margin-bottom: 10px; }
  button, select { margin-right: 5px; }
  #custom-legend-wrapper {
    position: sticky;
    top: 0;
    background: white;
    z-index: 999;
    text-align: center;
    padding: 5px 0;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
  }
  .legend-item {
    display: inline-block;
    margin: 0 10px;
    font-size: 14px;
  }
  .legend-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 4px;
    vertical-align: middle;
  }
  .modal {
    display: none;
    position: fixed;
    z-index: 2000;
    left: 0; top: 0;
    width: 100%; height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.5);
  }
  .modal-content {
    background-color: #fff;
    margin: 10% auto;
    padding: 20px;
    width: 80%;
    max-height: 70%;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }
  .close-button {
    float: right;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
  }
  #userTable {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  #userTable th, #userTable td {
    border: 1px solid #ccc;
    padding: 6px 10px;
    text-align: left;
  }
  #userTable tbody tr:nth-child(odd) {
    background-color: #f9f9f9;
  }
  #userTable tbody tr:nth-child(even) {
    background-color: #e5e7eb;
  }
  #userTable tbody tr:hover {
    background-color: #b5e0e6;
    cursor: default;
  }
</style>

<script>
// The full dashboard JS from dyanmic-api-loc.html should be migrated to the component's TypeScript file, not inline here. For now, this is a placeholder.
</script>
